import React from 'react';
import { Apple } from 'lucide-react';

const AdminDietsPage = () => {
  return (
    <div data-testid="admin-diets-page">
      <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Mi Dieta</h1>
      <p className="text-gray-500 mb-8">Gestiona los planes nutricionales asignados a los clientes</p>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-12 text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-lime-50 to-green-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Apple size={32} className="text-lime-400" />
        </div>
        <h2 className="text-lg font-bold text-gray-700 mb-1">Proximamente</h2>
        <p className="text-sm text-gray-400">La gestion de dietas estara disponible pronto</p>
      </div>
    </div>
  );
};

export default AdminDietsPage;
